import SERVERS from '../resources/js/servers';

const VueServersPlugin = {
  install(Vue) {
    if (!Object.prototype.hasOwnProperty.call(Vue, '$servers')) {
      Object.defineProperty(Vue.prototype, '$servers', {
        get: function get() { return SERVERS; },
      });
    }
  },
};

export default VueServersPlugin;
